var render = function render(){var _vm=this,_c=_vm._self._c;return _c('RelatedCellList',{directives:[{name:"infinite-scroll",rawName:"v-infinite-scroll",value:(_vm.loadMore),expression:"loadMore"}],key:"infinite_related_cell_list",attrs:{"cell-list":_vm.cellList,"thumbnail-info":_vm.thumbnailInfo,"content-info":_vm.contentInfo,"infinite-scroll-distance":"100","infinite-scroll-throttle-delay":"200"}})
}
var staticRenderFns = []

export { render, staticRenderFns }